import React from 'react';
import i18next from 'i18next';
import { string, bool, shape } from 'prop-types';
import cn from 'classnames';
import { number } from 'prop-types';

import { useFormatPrice } from '~hooks/useFormatPrice';

import styles from './styles.module.scss';

function PriceRow({ text, value, bold: isBold, discount, hasDivider, noMoneySymbol, metadata }) {
  const style = cn({ bold: isBold }, 'font-size-14');
  const formatPrice = useFormatPrice();
  const price = formatPrice(value);
  return (
    <>
      {hasDivider && <hr className={styles.divider} />}
      <div className="row middle space-between">
        <span className={style}>{i18next.t(`OrdersDetails:${text}`, metadata)}</span>
        <span className={style}>{noMoneySymbol ? value : discount ? `- ${price}` : price}</span>
      </div>
    </>
  );
}

PriceRow.propTypes = {
  text: string.isRequired,
  value: number.isRequired,
  bold: bool,
  discount: bool,
  hasDivider: bool,
  metadata: shape({ loyaltyProgramName: string }),
  noMoneySymbol: bool
};

PriceRow.defaultProps = {
  noMoneySymbol: false
};

export default PriceRow;
